<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        お知らせ - 新規登録
        <div class="headerBtn" @click="screenTransition(notifiationslistPath)" style="margin: 0px 0px 0px 20px;">一覧に戻る</div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || postLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 登録エラー表示 -->
      <div v-if="postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの登録中に問題が発生しました。
          </div>
        </div>
      </div>
      <form v-if="!getLodingFlg && !getErrorFlg">
        <validation-observer ref="obs" v-slot="ObserverProps">
          <div class="inputTitle" style="display: flex;">
            カテゴリー
          </div>
          <div class="row">
            <validation-provider name="カテゴリー" rules="required" mode="lazy">
              <div slot-scope="ProviderProps">
                <div class="selectdiv">
                  <select  v-model="detail.notificationCategory" @change='changeCategory'>
                    <option value="" selected>カテゴリーを選択</option>
                    <option v-for="categories in optioncategories"
                      v-bind:value="categories.id">
                      {{ categories.name }}
                    </option>
                  </select>
                </div>
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
          <div class="inputTitle" style="display: flex;">
            タイトル
          </div>
          <div class="row">
            <validation-provider name="タイトル" rules="required|max:255" mode="lazy">
              <div slot-scope="ProviderProps">
                <input class="text large" v-model="detail.notificationTitle"  style="width: 500px;">
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
          <div class="inputTitle" style="display: flex;">
            本文（HTML不可）
          </div>
          <div class="row">
            <validation-provider name="本文" rules="required|max:65535" mode="lazy">
              <div slot-scope="ProviderProps">
                <textarea class="text large" rows="10" cols="60" v-model="detail.notificationText" style="height: 200px; width: 500px; overflow-y: auto;">
                </textarea>
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>
          <div class="inputTitle" style="display: flex;">
            有効期限
          </div>
          <div class="row">
            <validation-provider name="有効期限" rules="futureDay|required" mode="lazy">
              <div slot-scope="ProviderProps">
                <input type="date" max='9999-12-31'class="text large" v-model="detail.notificationLimit">
                <div class="errMsg" v-if="ProviderProps.errors[0]">
                  <span class="errSpan">
                    {{ ProviderProps.errors[0] }}
                  </span>
                </div>
              </div>
            </validation-provider>
          </div>

          <div class="buttonGroup">
            <button class="btn" @click="confirm" type = "button"
              v-bind:class="{ disabled: isProcessing() || ObserverProps.invalid || !ObserverProps.validate, active: !ObserverProps.invalid && ObserverProps.validate}"
              :disabled="ObserverProps.invalid || isProcessing()">登録
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import moment from 'moment';
import ApiClient from '../services/ApiClient';
import common from '../services/common';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'お知らせ登録',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  data() {
    return {
      notifiationslistPath: '/notifications', // お知らせ一覧パス
      // 入力項目モデル
      detail: {
        notificationCategory: '', // カテゴリー
        notificationTitle: '', // タイトル
        notificationText: '', // 本文
        notificationLimit: common.getToday(), // 有効期限
      },
      // ドロップダウンリスト
      selectedcategories: '', // 選択お知らせカテゴリ
      optioncategories: [],   // お知らせカテゴリ配列
      // ローディング
      getLodingFlg: false,    // データ取得時ローディング用フラグ
      getErrorFlg: false,     // データ取得時エラーフラグ
      postLodingFlg: false,   // データ登録時ローディングフラグ
      postErrorFlg: false,    // データ登録時エラーフラグ
      processing: false,
      errorMessage: '',
    };
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  async mounted() {
    try {
      this.getLodingFlg = true;
      // お知らせカテゴリ取得API呼出
      this.optioncategories = await this.callGetNotificationCategories();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  methods: {
    // お知らせカテゴリ取得API呼び出し
    async callGetNotificationCategories() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getNotificationCategories();
      } catch (error) {
        this.errorMessage = error.message;
        throw error;
      }
    },
    // 登録ボタン押下時処理
    async confirm() {
      try {
        this.startProcessing();
        this.postLodingFlg = true;
        this.postErrorFlg = false;
        // カレンダーの値をUnixtimeへ変換
        const notificationExpiredAt = common.unixTimeFormat(this.detail.notificationLimit);
        // お知らせ新規登録API呼び出し
        const body = {
          notificationCategoryId: this.selectedcategories,
          title: this.detail.notificationTitle,
          body: this.detail.notificationText,
          expiredAt: notificationExpiredAt,
        };
        const restResourceService = new ApiClient();
        await restResourceService.postNotification(body);
        // お知らせ一覧画面に戻る
        this.screenTransition(this.notifiationslistPath);
      } catch (error) {
      this.errorMessage = error.message;
      this.postErrorFlg = true;
      this.endProcessing();
      } finally {
        this.postLodingFlg = false;
        this.endProcessing();
      }
    },
    // プルダウン選択内容取得・更新
    changeCategory(value) {
      this.selectedcategories = value.target.value;
    },
    // 画面遷移
    screenTransition(path) {
      history.back();
    },
    // チャタリング防止
    startProcessing() {
      this.processing = true;
    },
    endProcessing() {
      this.processing = false;
    },
    isProcessing() {
      return this.processing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

</style>
